

@if (!laboratoireReferenceNonModifiable()) {
  <div class="detail-card-labo">
    <div class="row">
      <div class="col">
        <hr class="separator-structure">
        <span class="font-weight-bold encart-labo entete-part-labo">{{ 'moduleLaboratoire.structureRecherche' | translate }}</span>
      </div>
    </div>
    @if (user.laboratoire === null || !user.laboratoire['laboratoireReference'] || user.laboratoire['laboratoireReference'] === null) {
      <div class="row mt-1">
        <div class="col">
          <div style="width: 590px; margin: auto auto; height: 75px">
            <button mat-raised-button color="accent" (click)="searchStructure()">
              <mat-icon class="mat-icon">search</mat-icon>
              {{ 'moduleLaboratoire.chercherStructureFrancaise' | translate }}
            </button>
            <span class="divider" style="margin-left: 10px; margin-right: 10px; font-weight: bold;">OU</span>
            <button mat-raised-button color="accent" (click)="addNewLaboRef()">
              <mat-icon class="mat-icon">add</mat-icon>
              {{ 'moduleLaboratoire.ajouterHorsFrance' | translate }}
            </button>
            <div class="clearfix"></div>
            <p class="invalid-feedback display-block" style="margin-top: 10px">
              <mat-icon style="vertical-align: bottom;">info</mat-icon>
              {{ 'moduleLaboratoire.ajoutObligatoire' | translate }} <span class="star">*</span>
            </p>
          </div>
        </div>
      </div>
    }
    @if (user.laboratoire !== null && user.laboratoire['laboratoireReference'] && user.laboratoire['laboratoireReference'] !== null) {
      <div class="row mt-1">
        <div class="col">
          <p>{{ 'moduleLaboratoire.nomEtablissement' | translate }}  {{user.laboratoire['laboratoireReference']['label']}}</p>
          <p>{{ 'general.laboratoire.adresse' | translate }} <strong>
            {{ user.laboratoire['laboratoireReference']['adresse']['adresseComplete'] }}
          </strong></p>
          <p>{{ 'moduleLaboratoire.direction' | translate }} {{(user.laboratoire['laboratoireReference']['directeur']['civilite'] === 'm') ? 'Mr. ' : 'Mme. '}}
            {{user.laboratoire['laboratoireReference']['directeur']['nom']}}
          {{user.laboratoire['laboratoireReference']['directeur']['prenom']}}</p>
        </div>
      </div>
    }
    @if (user.laboratoire !== null && user.laboratoire['laboratoireReference'] && user.laboratoire['laboratoireReference'] !== null) {
      <div class="row">
        <div class="col">
          <button mat-stroked-button color="accent"
            (click)="deleteLaboRef()">
            <mat-icon>autorenew</mat-icon>
            {{ 'front.profil.supprimerStructure' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
}


@if (laboratoireReferenceNonModifiable() && user['laboratoire'] && user['laboratoire']['laboratoireReference']) {
  <div>
    <div class="row">
      <div class="col">
        <hr class="separator-structure">
        <span class="font-weight-bold encart-labo entete-part-labo">{{ 'moduleLaboratoire.structureRecherche' | translate }}</span>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="label">{{ 'moduleLaboratoire.nomEtablissement' | translate }} <span
              class="star">*</span></label>
              <input type="text" class="form-control" id="label"
                [(ngModel)]="user.laboratoire['laboratoireReference'].label" (ngModelChange)="update()">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <app-geocoder [adresse]="user.laboratoire['laboratoireReference'].adresse"
              (place)="user.laboratoire['laboratoireReference'].adresse = $event; update()"></app-geocoder>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <p>{{ 'moduleLaboratoire.direction' | translate }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label for="directeurCivilite">{{ 'general.civilite' | translate }}  <span class="star">*</span></label>
                <mat-select class="form-control" name="directeurCivilite" id="directeurCivilite"
                  [compareWith]="compareByLetter"
                  [(ngModel)]="user.laboratoire['laboratoireReference'].directeur.civilite" required
                  (ngModelChange)="update()">
                  <mat-option value="f">{{ 'general.madame' | translate }}</mat-option>
                  <mat-option value="m">{{ 'general.monsieur' | translate }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="directeur_nom">{{ 'general.personne.nom' | translate }} <span class="star">*</span></label>
                <input class="form-control" name="directeur_nom" id="directeur_nom" type="text"
                  [(ngModel)]="user.laboratoire['laboratoireReference'].directeur.nom"
                  (ngModelChange)="update()"/>
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group">
                  <label for="directeur_prenom">{{ 'general.prenom' | translate }} <span
                  class="star">*</span></label>
                  <input class="form-control" name="directeur_prenom" id="directeur_prenom" type="text"
                    [(ngModel)]="user.laboratoire['laboratoireReference'].directeur.prenom"
                    (ngModelChange)="update()"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button mat-stroked-button color="accent"
                    (click)="deleteLaboRef()">
                    <mat-icon>autorenew</mat-icon>
                    {{ 'front.profil.supprimerStructure' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }


      <div class="row mt-1">
        <div class="col">
          <hr class="separator-structure">
          <span class="font-weight-bold encart-labo entete-part-labo">{{ 'moduleLaboratoir.precisezLaboratoire' | translate }}</span>
        </div>
      </div>
      @if (user.laboratoire !== null) {
        <div class="row mt-1">
          <div class="col-6">
            <fieldset
              class="form-group {{(user.laboratoire['nom'] === '' || user.laboratoire['nom'] === null ) ? 'form-error' : ''}}">
              <label for="etablissement">{{ 'moduleLaboratoire.nomLaboratoireUniteService' | translate }}<span
              class="star">*</span> </label>
              <input id="etablissement" placeholder="{{ 'moduleLaboratoire.saisisezNomEtablissement' | translate }}"
                type="text" class="form-control"
                [(ngModel)]="user.laboratoire['nom']" (ngModelChange)="update()">
                @if (user.laboratoire['nom'] === '' || user.laboratoire['nom'] === null ) {
                  <div
                    class="invalid-feedback display-block">
                    {{'general.champObligatoire' | translate}}
                  </div>
                }
              </fieldset>
            </div>
            <div class="col-4">
              <fieldset class="form-group">
                <label for="equipe">{{ 'general.equipe' | translate }}</label>
                <input id="equipe" placeholder="{{ 'moduleLaboratoire.saisissezEquipe' | translate }}" type="text"
                  class="form-control"
                  [(ngModel)]="user.laboratoire['division']" (ngModelChange)="update()">
                </fieldset>
              </div>
            </div>
          }
          @if (user.laboratoire['directeurDivision']) {
            <div class="row">
              <div class="col">
                <p>{{ 'moduleLaboratoire.direction' | translate }}</p>
              </div>
            </div>
          }
          @if (user.laboratoire['directeurDivision'] !== undefined) {
            <div class="row">
              <div class="col">
                <fieldset
                  class="form-group {{(user.laboratoire['directeurDivision']['personne']['civilite'] === '' || user.laboratoire['directeurDivision']['personne']['civilite'] === null ) ? 'form-error' : ''}}">
                  <label for="civilite">{{ 'general.civilite' | translate }} <span class="star">*</span></label>
                  <mat-select class="form-control" [(ngModel)]="user.laboratoire['directeurDivision']['personne']['civilite']"
                    id="civilite"
                    [compareWith]="compareByLetter" required (ngModelChange)="update()">
                    <mat-option value="f">{{ 'general.madame' | translate }}</mat-option>
                    <mat-option value="m">{{ 'general.monsieur' | translate }}</mat-option>
                  </mat-select>
                  @if (user.laboratoire['directeurDivision']['personne']['civilite'] === '' || user.laboratoire['directeurDivision']['personne']['civilite'] === null) {
                    <div
                      class="invalid-feedback display-block">
                      {{'general.champObligatoire' | translate}}
                    </div>
                  }
                </fieldset>
              </div>
              <div class="col">
                <fieldset class="form-group"
                  [class.form-error]="user.laboratoire['directeurDivision']['personne']['nom'] === '' || user.laboratoire['directeurDivision']['personne']['nom'] === null ">
                  <label for="nomDir">{{ 'general.personne.nom' | translate }} <span class="star">*</span></label>
                  <input id="nomDir" type="text" class="form-control"
                    [(ngModel)]="user.laboratoire['directeurDivision']['personne']['nom']" (ngModelChange)="update()">
                    @if (user.laboratoire['directeurDivision']['personne']['nom'] === '' || user.laboratoire['directeurDivision']['personne']['nom'] === null ) {
                      <div
                        class="invalid-feedback display-block">
                        {{'general.champObligatoire' | translate}}
                      </div>
                    }
                  </fieldset>
                </div>
                <div class="col">
                  <fieldset class="form-group"
                    [class.form-error]="user.laboratoire['directeurDivision']['personne']['prenom'] === '' || user.laboratoire['directeurDivision']['personne']['prenom'] === null ">
                    <label for="prenomDir">{{'general.prenom' | translate }} <span class="star">*</span></label>
                    <input id="prenomDir" type="text" class="form-control"
                      [(ngModel)]="user.laboratoire['directeurDivision']['personne']['prenom']" (ngModelChange)="update()">
                      @if (user.laboratoire['directeurDivision']['personne']['prenom'] === '' || user.laboratoire['directeurDivision']['personne']['prenom'] === null ) {
                        <div
                          class="invalid-feedback display-block">
                          {{'general.champObligatoire' | translate}}
                        </div>
                      }
                    </fieldset>
                  </div>
                </div>
              }
              <div class="row mt-1">
                <div class="col">
                  <h6 class="font-weight-bold">{{ 'moduleLaboratoire.adresseLaboratoire' | translate }}</h6>
                </div>
              </div>


              <div class="row mt-1">
                <div class="col">
                  <app-geocoder #geocoder [adresse]="user.laboratoire['adresse']"
                  (place)="user.laboratoire['adresse'] = $event; update()"></app-geocoder>
                </div>
              </div>


